import { checkValue } from 'src/components/common/helper';

export const useConstructCtaUrl = (ctaUrl: string, window: any, id: string) => {
  const currentLocation = window?.location?.pathname;
  const host = window?.location?.host;
  const protocol = window?.location?.protocol;

  let link = '';
  if (checkValue(ctaUrl)) {
    link = !ctaUrl.startsWith('/') && !ctaUrl.startsWith('http') ? `/${ctaUrl}` : ctaUrl;
    if (!link.includes('http') && checkValue(host) && checkValue(protocol)) {
      link = `${protocol}//${host}${link}`;
    }
    const urlObj = new URL(link);
    const searchParams = new URLSearchParams(urlObj.search);
    let ckoflag = searchParams.get('ckoflag');
    let uurl = searchParams.get('uurl');
    let rurl = searchParams.get('rurl');

    let needsUpdate = false;

    // Check and update ckoflag if necessary
    if (ckoflag !== '0') {
      searchParams.set('ckoflag', '0');
      needsUpdate = true;
    }

    // Check and update uurl if necessary
    if (uurl !== 'e3id=redr') {
      searchParams.set('uurl', 'e3id=redr');
      needsUpdate = true;
    }

    // Check and add rurl if missing
    if (!checkValue(rurl)) {
      searchParams.set('rurl', `${currentLocation}#${id}`); // Set to a default value if needed
      needsUpdate = true;
    }

    // Update the URL if any parameter was modified
    if (needsUpdate) {
      urlObj.search = searchParams.toString();
      link = urlObj.toString();
    }
  } else {
    if (checkValue(currentLocation)) {
      link = `/login?ckoflag=0&uurl=${encodeURIComponent(`e3id=redr&rurl=${currentLocation}#${id}`)}`;
    }
  }

  return !link.startsWith('/') && !link.startsWith('http') ? `/${link}` : link;
};
